import React, { Component } from "react";
import "./ExperienceCard.css";
import { Fade } from "react-reveal";

class ExperienceCard extends Component {
  render() {
    const experience = this.props.experience;
    const index = this.props.index;
    const totalCards = this.props.totalCards;
    const theme = this.props.theme;
    return (
      <div className="experience-list-item" style={{ marginTop: index === 0 ? 30 : 50 }}>
        <Fade left duration={2000} distance="40px">
          <div className="experience-card-logo-div">
            <img
              className="experience-card-logo"
              src={require(`../../assets/images/${experience["logo_path"]}`)}
              alt=""
            />
          </div>
        </Fade>
        <Fade bottom duration={2000} distance="40px" style={{ flex: 1 }}>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <div className="arrow-left" style={{ borderRight: `10px solid ${theme.body}` }}></div>
            <div className="experience-card" style={{ background: `${theme.body}` }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h3 className="experience-card-title" style={{ color: theme.text }}>
                    {experience["title"]}
                  </h3>
                  <p className="experience-card-company" style={{ color: theme.text }}>
                    {experience.company_url ? (
                      <a href={experience.company_url} target="_blank" rel="noopener noreferrer">
                        {experience.company}
                      </a>
                    ) : (
                      experience.company
                    )}
                  </p>
                </div>
                <div>
                  <div className="experience-card-heading-right">
                    <p className="experience-card-duration" style={{ color: theme.secondaryText }}>
                      {experience["duration"]}
                    </p>
                    <p className="experience-card-location" style={{ color: theme.secondaryText }}>
                      {experience["location"]}
                    </p>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginTop: 20,
                }}
              >
                <div style={{ color: theme.text, whiteSpace: "pre-wrap" }}>{experience["description"]}</div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}

export default ExperienceCard;
